import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exteriorView03ImageOptions } from './views/ExteriorView03'

class Xr41HullTreatment extends Component {

	constructor(props) {
		super(props);
		this.state = { overlayUrls: [] };
		this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
		this.handleOverlayUrls = this.handleOverlayUrls.bind(this);
	}

	handleOverlayUrls(urls) {
		const current = this.state.overlayUrls;
		if (urls.length !== current.length || urls.some((u, i) => u !== current[i])) {
			this.setState({ overlayUrls: urls });
		}
	}


	handleHullTreatmentChange(newValue) {
		let configuration = this.props.configuration;
		configuration.HullTreatment = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}



	render() {
		let imageOptions = exteriorView03ImageOptions;


		let image = (
			<div style={{ position: 'relative' }}>
				<TransomConfigurator
					colorMultiplier={0.75}
					name={this.props.transom.Name}
					port={this.props.transom.Port}
					transomSize={{ width: 2222, height: 610 }}
					transform={[
						0.033626, -0.037713, 0, -9.9e-5,
						-0.016676, 0.064141, 0, -5.9e-5,
						0, 0, 1, 0,
						175.299607, 195.768245, 0, 1
					]}
				>
					<ConfiguratorImage boat="Xr41" configuration={this.props.configuration} options={imageOptions} onOverlayUrls={this.handleOverlayUrls} />
				</TransomConfigurator>
				{this.state.overlayUrls.length > 0 && (
					<div style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none', zIndex: 10 }}>
						{this.state.overlayUrls.map((url) => (
							<img key={url} src={url} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', objectFit: 'contain' }} />
						))}
					</div>
				)}
			</div>
		);

		return (
			<ConfiguratorSection image={image}>

				<ConfiguratorOption>
					<h1><Trans defaults='Hull treatment' /></h1>

					<p><Trans defaults='3 layers of sprayed epoxy primer & 2 layers of antifouling paint. To achieve a smooth and high quality finished the bottom treatment is sprayed onto the hull.' /></p>

					<RadioGroup label={this.props.t("Treatment options:")} options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

				</ConfiguratorOption>
			</ConfiguratorSection>
		);
	}
}

export default withTranslation()(Xr41HullTreatment);


// WEBPACK FOOTER //
// ./src/Xr41/Xr41HullTreatment.js